<template>
  <div class="drawItem" v-bind:class="{
    excl:exclusive===1,
    focus:focus,
    removed:myremoved === 1,
    rolling:rolling && !mydrawed ,
    drawed:mydrawed,
    item_blue:type==1,
    item_orange:type==2,
    item_puple:type==3,
    item_box:type==4
  }" @click="choose">
    <div class="drawItemImg">
      <img :src="img"/>
      <span v-if="num>1">X {{num}}</span>
    </div>
    <p class="text-center">{{name}}</p>
  </div>
</template>

<script>
    export default {
        data () {
            return {
                myremoved: 0,
                rolling: 0,
                focus: false,
                mypk: 0,
                mydrawed: 0
            }
        },
        props: {
            name: '',
            img: '',
            quality: '',
            num: 0,
            pk: 0,
            pos: 0,
            unique: 0,
            exclusive: 0,
            status: 0,
            drawed: 0,
            removed: 0,
            type: 0
        },
        methods: {
            choose () {
                if (this.exclusive === 1) {
                    return false
                }
                if (this.status === 0) {
                    if (this.myremoved === 0) {
                        this.myremoved = 1
                        this.$emit('fadedItem', {pk: this.pk, status: this.myremoved})
                    } else {
                        this.myremoved = 0
                        this.$emit('fadedItem', {pk: this.pk, status: this.myremoved})
                    }
                }
            },
            setChoose (status) {
                this.myremoved = status
            },

            startRolling () {
                if (this.mydrawed || this.removed) {
                    return
                }
                this.rolling = true
            },
            stopRolling () {
                if (this.mydrawed || this.removed) {
                    return
                }
                this.rolling = false
            },
            setFocus () {
                if (this.mydrawed || this.removed || this.focus) {
                    return false
                }
                this.focus = true
                return true
            },
            removeFocus () {
                this.focus = false
            },
            getPK () {
                return this.mypk
            }
        },
        watch: {
            removed: {
                immediate: true,
                handler (val) {
                    this.myremoved = val
                }
            },
            pk: {
                immediate: true,
                handler (val) {
                    this.mypk = val
                }
            },
            drawed: {
                immediate: true,
                handler (val) {
                    this.mydrawed = val
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/items/drawItem.vue